import { LayoutName, LayoutNameSchema } from "@monkeytype/contracts/schemas/layouts";

export const LayoutsList:LayoutName[] = LayoutNameSchema._def.values;